import React from "react";
import _ from "lodash";
import CardButton from "./Button";
import { ReactComponent as DeleteEntrySvg } from "assets/images/challenges/delete-entry-icon.svg";

const DeleteEntryModal = ({
  onCloseModal,
  onDeleteEntry,
  selectedEntry,
  entries_params
}) => {
  const delete_label = _.get(
    entries_params,
    "delete_label",
    "Delete this entry?"
  );
  const your_entry = _.get(entries_params, "your_entry", "Your Entry:");
  const entry_time = _.get(entries_params, "entry_time", "Entry Time:");
  const delete_button_text = _.get(
    entries_params,
    "delete_button_text",
    "Delete"
  );
  const delete_cancel = _.get(entries_params, "delete_cancel", "Cancel");

  return (
    <div className="delete-modal-container">
      <div className="delete-modal-inner">
        <DeleteEntrySvg />
        <h2 className="modal-title">{delete_label}</h2>
        <div className="entry-details-container">
          <div className="entry-count">
            <span className="count-label">{your_entry} </span>
            <span className="count-value">{`${selectedEntry.entry} steps`}</span>
          </div>
          <div className="entry-count">
            <span className="count-label">{entry_time} </span>
            <span className="count-value">{selectedEntry.time}</span>
          </div>
        </div>
        <CardButton
          text={delete_button_text}
          class_name="error"
          onPress={onDeleteEntry}
        />
        <p className="cancel-text" onClick={onCloseModal}>
          {delete_cancel}
        </p>
      </div>
    </div>
  );
};

export default DeleteEntryModal;
